import { makeStyles } from '@material-ui/core/styles';
import { LightenDarkenColor } from 'lighten-darken-color';

export const useStyles = (error) =>
  makeStyles((theme) => ({
    dropZoneContainer: {
      width: '100%',
      maxWidth: '662px',
      marginBottom: '40px',
      position: 'relative',
    },
    dropZoneDescription: {
      color: theme.palette.text.primary,
      fontSize: theme.custom.fontSize.primary,
      marginBottom: theme.custom.margin.m20,
    },
    dropZoneHintm8: {
      color: theme.palette.text.primary,
      fontSize: theme.custom.fontSize.primary,
      marginTop: theme.custom.margin.m8,
    },
    dropZoneHint: {
      color: theme.palette.text.primary,
      fontSize: theme.custom.fontSize.primary,
    },
    dropZoneError: {
      marginTop: theme.custom.margin.m10,
      color: theme.palette.error.main,
    },
    dropZoneLayout: {
      display: 'flex',
      minHeight: '180px',
      maxHeight: '180px',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: error ? '#fff' : LightenDarkenColor(`${theme.palette.primary.main}`, 250),
      borderWidth: '1px',
      borderStyle: 'dashed',
      borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
      position: 'relative',
      cursor: 'pointer',
      padding: '33px 20px 21px',
    },
    dropZoneIcon: {
      fontSize: 50,
      color: theme.palette.primary.main,
      marginBottom: theme.custom.margin.m20 - 8,
    },
    dropZoneLabel: {
      fontSize: theme.custom.fontSize.primary,
      padding: 0,
      margin: `0 0 ${theme.custom.margin.m20 / 2}px`,
      color: error ? '#80868B' : `${theme.palette.text.primary}`,
    },
    dropZoneButton: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white, // Change color to white for GG only. will revert to previous one i.e. //theme.palette.text.secondary,
      '&:hover': { backgroundColor: theme.palette.primary.main },
    },
    dropZoneCancelButton: {
      color: theme.palette.primary.main,
    },
  }));
